export default "__VITE_ASSET__CbvWU2cs__"